<template>
    <div class="edit-password-wp">
        <div class="w-1200 edit-password-1">
            <div class="title-more">
                <i class="el-icon-s-home" style="color:#615E61;position:relative;top:16px;left:10px;"> </i>
                <el-breadcrumb style="width:90%;padding-left:40px;"  separator=" - ">
                    <el-breadcrumb-item :to="{path:'/home'}">首页</el-breadcrumb-item>
                    <el-breadcrumb-item>修改密码</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="title-more">
                <div class="t-m-blue"></div>
                <p class="t-m-t">修改密码</p>
            </div>
             <el-form ref="form" :model="form" :rules="rules" label-width="100px" style="width:40%;margin:50px auto 0 auto;">
                <el-form-item  label="旧密码" prop="oldPassword">
                    <el-input v-model="form.oldPassword" type="password"  placeholder="旧密码"></el-input>
                </el-form-item>
                <el-form-item label="验证码" prop="yzm">
                    <el-input v-model="form.yzm" style="width:180px;" prefix-icon="el-icon-circle-check" placeholder="请输入邮箱验证码"></el-input>
                    <el-button type="primary"  style="margin-left:20px;" :loading="buttonLoading" @click="getPasWordYzm">{{buttonText}}</el-button>
                </el-form-item>
                <el-form-item  label="新密码" prop="newPassword1">
                    <el-input v-model="form.newPassword1" type="password"  placeholder="新密码"></el-input>
                </el-form-item>
                <el-form-item label="重复新密码" prop="newPassword2">
                    <el-input v-model="form.newPassword2" type="password"  placeholder="重复新密码"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary"  @click="submitForm('form')">确认修改</el-button>
                </el-form-item>
             </el-form>
        </div>
    </div>
</template>
<script>
import EditPassword from './EditPassword.js';
export default EditPassword;
</script>
<style lang="scss" scoped>
@import './EditPassword.scss';
</style>